import { collection, doc, runTransaction, type Firestore } from 'firebase/firestore';

/** Serialize pending History creation against the server class-deletion lock.
 * This is concurrency coordination; existing Firestore rules remain authoritative.
 * A retry that sees the lock or missing parent writes no History record.
 */
export async function savePendingObservationDeletionHistory(
  db: Firestore, record: Record<string, unknown>, classId: string,
): Promise<string> {
  const historyRef = doc(collection(db, 'deletionHistory'));
  const classRef = doc(db, 'classes', classId);
  await runTransaction(db, async transaction => {
    const currentClass = await transaction.get(classRef);
    if (!currentClass.exists() || currentClass.data().observationDeletionState === 'deleting') {
      throw new Error('Class deletion has started or the class is missing. No student deletion was started.');
    }
    transaction.set(historyRef, record);
  });
  return historyRef.id;
}
